import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2ConfiguratorImageWithOverlays from './X46MK2ConfiguratorImageWithOverlays'
import ConfiguratorOption from './../ConfiguratorOption'
import MaterialSelector from '../MaterialSelector'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView08ImageOptions } from './views/ExteriorView08'

class X46MK2Sprayhood extends Component {
  constructor (props) {
    super(props)
    this.handleSprayhoodChange = this.handleSprayhoodChange.bind(this)
    this.handleBoomCoverChange = this.handleBoomCoverChange.bind(this)
  }

  handleSprayhoodChange (newValue) {
    let configuration = this.props.configuration
    configuration.SprayhoodFabric = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleBoomCoverChange (newValue) {
    let configuration = this.props.configuration
    configuration.BoomCover = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = exteriorView08ImageOptions

    let image = (
      <X46MK2ConfiguratorImageWithOverlays
        boat='X46MK2'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Sprayhood &amp; Boom Cover' />
          </h1>

          <p>
            <Trans defaults='Excellent cockpit protection, with various options.' />
          </p>
          <p>
            <Trans defaults='In this configurator you can visualize the sprayhood options only. On the X4<sup>6</sup> model, we have developed 2 different versions of sprayhood - standard and extended.' />
          </p>
          <p>
            <Trans defaults='Apart from the options below - sprayhood and boom cover - there are also options for cockpit tent, bimini, cockpit cushions and forestay cover. These options are not included in the configurator. Please, contact your local dealer for more information.' />
          </p>
          <h2>
            <Trans defaults='Sprayhood' />
          </h2>
          <MaterialSelector
            label={this.props.configuration.SprayhoodFabric.label}
            options={this.props.sprayhoodOptions}
            value={this.props.configuration.SprayhoodFabric}
            onChange={this.handleSprayhoodChange}
          />

          <h2>
            <Trans defaults='Boom Cover' />
          </h2>
          <MaterialSelector
            label={this.props.configuration.BoomCover.label}
            options={this.props.boomCoverOptions}
            value={this.props.configuration.BoomCover}
            onChange={this.handleBoomCoverChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2Sprayhood)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2Sprayhood.js